import { createSlice } from '@reduxjs/toolkit'
import name from './name'

export const onboarding = createSlice({
  name,
  initialState: {
    playlistPopperOpen: false,
    myLearningBadge: false,
    myLearningFeedback: false,
    onboarding: {}
  },
  reducers: {
    setOnboardingProfile: (state, { payload }) => {
      state.playlistPopperOpen = payload.onboarding.playlists.show && !payload.onboarding.playlists.onboarded
      state.onboarding = {
        ...payload
      }
      state.myLearningBadge = payload.onboarding.myLearning.show && !payload.onboarding.myLearning.onboarded
      state.myLearningFeedback = payload.onboarding.myLearningFeedback.show && !payload.onboarding.myLearningFeedback.onboarded
    },
    openPlaylistPopper: (state) => {
      state.playlistPopperOpen = false
    },
    closePlaylistPopper: (state) => {
      state.playlistPopperOpen = false
    },
    removeMyLearningBadge: (state) => {
      state.myLearningBadge = false
    },
    dismissMyLearningFeedback: (state) => {
      state.myLearningFeedback = false
    }
  }
})

export const { setOnboardingProfile, openPlaylistPopper, closePlaylistPopper, removeMyLearningBadge, dismissMyLearningFeedback } = onboarding.actions

export default onboarding.reducer
